import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class EmailService {

    static emailResend = (id, callback, errCallback) => {
        NetworkService.post(`${API_BASE_URL}/email/resend`, {}, callback, errCallback, [
            ['userActionId', id]
        ]);
    };

}
